import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  PaidFeature,
  SubscriptionPlan,
  SubscriptionWithPaidFeatures,
} from '../../../projects/client';
import { DemoSettingsActions } from './demo-settings.actions';
import { DemoSettingsSelectors } from './demo-settings.selectors';

@Injectable({ providedIn: 'root' })
export class DemoSettingsStore {
  constructor(private store: Store) {}

  selectSubscriptionWithPaidFeatures$ = this.store.select(
    DemoSettingsSelectors.selectSubscriptionWithPaidFeatures
  );

  triggerAddFeatures(resourceId: string, features: PaidFeature[]): void {
    this.store.dispatch(DemoSettingsActions.addFeatures({ resourceId, features }));
  }

  triggerRemoveFeatures(resourceId: string, features: PaidFeature[]): void {
    this.store.dispatch(DemoSettingsActions.removeFeatures({ resourceId, features }));
  }

  triggerUpdatePlan(resourceId: string, plan: SubscriptionPlan): void {
    this.store.dispatch(DemoSettingsActions.updatePlan({ resourceId, plan }));
  }

  triggerRemoveDemoConfig(): void {
    this.store.dispatch(DemoSettingsActions.removeDemoConfig());
  }

  triggerLoadDemoConfig(): void {
    this.store.dispatch(DemoSettingsActions.loadDemoConfig.attempt());
  }

  getSubscriptionForResourceId(resourceId: string): Observable<SubscriptionWithPaidFeatures[]> {
    return this.store.select(DemoSettingsSelectors.getSubscriptionForResourceId(resourceId));
  }

  selectAreAllFeaturesEnabled(resourceId: string): Observable<boolean> {
    return this.store.select(DemoSettingsSelectors.selectAreAllFeaturesEnabled(resourceId));
  }

  selectIsFeatureEnabled(resourceId: string, paidFeature: PaidFeature): Observable<boolean> {
    return this.store.select(DemoSettingsSelectors.selectIsFeatureEnabled(resourceId, paidFeature));
  }
  selectCurrentPlan(resourceId: string): Observable<SubscriptionPlan> {
    return this.store.select(DemoSettingsSelectors.selectCurrentPlan(resourceId));
  }
}
